module.exports = __webpack_public_path__ + "img/building_services.813384f5.webp";